import React, { useState, useEffect } from "react";
import { useTheme, styled } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          className="float-end"
          size="large">
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const MailSMSLogModal = ({ handleClose, open, LogDataArray, ...props }) => {
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "mail-sms-log";

  let tblRef = null;

  return (
    <div>
      <BootstrapDialog
        onClose={() => handleClose("ProductBatch")}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth="md"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => handleClose("ProductBatch")}
        >
          {DispensingLanguage[lan][menukey]["Mail/SMS Log"]}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <div className="LogClass">
            {" "}
            <b>{DispensingLanguage[lan][menukey]["LogResult"]}:</b>{" "}
            {LogDataArray[0]}
          </div>
          <div className="LogClass">
            <b>{DispensingLanguage[lan][menukey]["EmailSendResponse"]}:</b>{" "}
            {LogDataArray[1]}
          </div>
          {/* <div className="LogClass">
            <b>{DispensingLanguage[lan][menukey]["SMSResponse"]}:</b>{" "}
            {LogDataArray[2]}
          </div> */}
          <div className="LogClass">
            <b>{DispensingLanguage[lan][menukey]["Massage"]}:</b>{" "}
            {LogDataArray[3]}
          </div>
        </DialogContent>

        <DialogActions>
          <Button
            autoFocus
            className="float-start"
            variant="contained"
            onClick={() => handleClose("ProductBatch")}
          >
            {DispensingLanguage[lan][menukey]["Close"]}
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default MailSMSLogModal;
